
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { List, DatetimePicker, Popup } from 'vant'
import { formatDate, getAddYear, getPreMonth } from '@/utils'
import { queryAllIntegral, queryIntegralRank } from '@/apis/portrait'
import { useRouter } from 'vue-router'
import { store } from '@/store'

export default defineComponent({
  components: {
    VanList: List,
    VanDatetimePicker: DatetimePicker,
    VanPopup: Popup
  },
  setup() {
    const router = useRouter()
    let list: any = []
    const formatter: any = (type: any, val: any) => {
      if (type === 'year') {
        return `${val}年`
      }
      if (type === 'month') {
        return `${val}月`
      }
      return val
    }

    const allUser: any = []
    const proxyData = reactive({
      loading: false,
      finished: false,
      formatter: formatter,
      monthPoints: 0,
      user: store.state.user,
      currentDate: new Date(getPreMonth('YYYY.MM')),
      nowDate: getPreMonth('YYYY.MM'),
      showPopup: false,
      minDate: getAddYear(-2),
      maxDate: getAddYear(0),
      list: list,
      allUser: allUser,
      page: 1,
      pageCount: 12,
      triggerShowPopup() {
        proxyData.showPopup = true
      },
      goIntegralDesc() {
        router.push({ path: '/integral-desc' })
      },
      comfirm() {
        // console.log(proxyData.currentDate);
        let time = formatDate('YYYY.MM', proxyData.currentDate)
        proxyData.page = 1
        proxyData.list = []
        proxyData.nowDate = time
        proxyData.showPopup = false
        //  查看当前月份的节能
        proxyData.list = []
        // 查看总数据
        proxyData.queryAllIntegral()
        proxyData.onLoad()
      },
      onLoad() {
        proxyData.queryIntegralRank()
      },
      /**
       * 获取上月的总积分
       */
      queryAllIntegral() {
        let time = formatDate('YYYYMM', new Date(proxyData.nowDate))
        var param = {
          criteria: {
            'date': time,
            projectId: proxyData.user.projectId,
            userId: proxyData.user.userId
          }
        }
        queryAllIntegral(param).then((res) => {
          const resData: any = res
          const resContent: any = resData?.content ?? []
          proxyData.monthPoints = resContent[0]?.totalPoints ?? 0
        })
      },
      /**
       * 获取节能排名
       */
      queryIntegralRank() {
        let time = formatDate('YYYYMM', new Date(proxyData.nowDate))
        var params: any = {
          criteria: {
            date: time
          },
          'orders': [
            {
              'column': 'totalPoints',
              'asc': false
            },
            {
              'column': 'userId',
              'asc': false
            }
          ],
          'page': proxyData.page,
          'size': proxyData.pageCount
        }
        queryAllIntegral(params).then(res => {
          // 加载状态结束
          proxyData.loading = false
          let resData: any = res
          let allRes = resData?.content ?? []
          if (allRes && allRes.length) {
            proxyData.page++
          } else {
            proxyData.finished = true
          }
          allRes.map((item: any) => {
            proxyData.list.push(item)
          })
          proxyData.setUserImg()
        }).catch(() => {
          proxyData.finished = true
        })
      },
      /**
       * 设置用户图像
       */
      setUserImg() {
        proxyData.list.map((ele: any) => {
          proxyData.allUser.filter((item: any) => {
            if (ele.userId == item.id) {
              ele.headImgUrl = item.headImgUrl
            }
          })
        })
      }
    })
    onMounted(() => {
      //  查看上一个月的节能
      proxyData.queryAllIntegral()
    })
    return {
      ...toRefs(proxyData)
    }
  }
})
